import React, { useState, useEffect, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { format } from 'date-fns';
import { useNavigate, useLocation } from 'react-router-dom';
import BackButton from '../../components/BackButton';

const apiUrl = process.env.REACT_APP_API_URL;

let dropdownTags = [];

// Plugin initialization function
// const initializeCustomPlugin = () => {
//   fetch(`${apiUrl}/Mailer/GetTagList`)
//     .then(response => {
//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }
//       return response.json();
//     })
//     .then(data => {
//       const myListItems = data.response.map(item => item.tagName);
//       dropdownTags = myListItems; // Store the tags globally
//       console.log(myListItems);
//       window.tinymce.PluginManager.add('MergeTagPlugin', function(editor) {
//         const menuItems = myListItems.map(tagName => ({
//           text: tagName,
//           onclick: function() {
//             editor.insertContent(`{${tagName}}`);
//           },
//         }));

//         editor.addButton('Tags', {
//           type: 'menubutton',
//           text: 'Merge Tags',
//           menu: menuItems,
//         });
//       });
//     })
//     .catch(error => {
//       console.error('Error fetching merge tags:', error);
//     });
// };

const CreateTemplate = () => {
  const [availableTags, setAvailableTags] = useState([]);
  const editorRef = useRef(null);
  const subjectInputRef = useRef(null);
  const [lastFocusedElement, setLastFocusedElement] = useState(null);
  const [variables, setVariables] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fromEmailOptions, setFromEmailOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState('');
  const [textAreaValue, setTextAreaValue] = useState('');
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const tinyMceEditorRef = useRef(null);
  const initializeCustomPlugin = () => {
    fetch(`${apiUrl}/Mailer/GetTagList`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        const myListItems = data.response.map(item => item.tagName);
        dropdownTags = myListItems;
        setAvailableTags(myListItems);
      })
      .catch(error => {
        console.error('Error fetching merge tags:', error);
      });
  };

  // const initializeCustomPlugin = () => {
  //   fetch(`${apiUrl}/Mailer/GetTagList`)
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then(data => {
  //       const myListItems = data.response.map(item => item.tagName);
  //       dropdownTags = myListItems;
  //       setAvailableTags(myListItems);

  //       window.tinymce.PluginManager.add('MergeTagPlugin', function (editor) {
  //         editor.on('init', function (e) {
  //           editorRef.current = editor;
  //         });

  //         const menuItems = myListItems.map(tagName => ({
  //           text: tagName,
  //           onclick: function () {
  //             editor.insertContent(`{${tagName}}`);
  //           },
  //         }));

  //         editor.addButton('Tags', {
  //           type: 'menubutton',
  //           text: 'Merge Tags',
  //           menu: menuItems,
  //         });
  //       });
  //     })
  //     .catch(error => {
  //       console.error('Error fetching merge tags:', error);
  //     });
  // };

  // Function to handle tag click and insertion
  // const handleTagClick = (tagName) => {
  //   const tagContent = `{${tagName}}`;

  //   if (lastFocusedElement === 'subject') {
  //     // Handle insertion in subject input
  //     const input = subjectInputRef.current;
  //     const start = input.selectionStart;
  //     const end = input.selectionEnd;
  //     const currentValue = emailData.Subject;
  //     const newValue = currentValue.substring(0, start) + tagContent + currentValue.substring(end);

  //     handleInputChange('Subject', newValue);

  //     // Reset cursor position after React updates the input value
  //     setTimeout(() => {
  //       input.focus();
  //       input.setSelectionRange(start + tagContent.length, start + tagContent.length);
  //     }, 0);
  //   } else if (editorRef.current) {
  //     // Handle insertion in TinyMCE editor
  //     editorRef.current.focus();
  //     editorRef.current.insertContent(tagContent);
  //   }
  // };
  const handleTagClick = (tagName) => {
    const tagContent = `{${tagName}}`;

    if (lastFocusedElement === 'subject') {
      // Handle insertion in subject input
      const input = subjectInputRef.current;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const currentValue = emailData.Subject;
      const newValue = currentValue.substring(0, start) + tagContent + currentValue.substring(end);

      handleInputChange('Subject', newValue);

      // Reset cursor position after React updates the input value
      setTimeout(() => {
        input.focus();
        input.setSelectionRange(start + tagContent.length, start + tagContent.length);
      }, 0);
    } else {
      // Handle insertion in TinyMCE editor
      if (tinyMceEditorRef.current) {
        tinyMceEditorRef.current.execCommand('mceInsertContent', false, tagContent);
      }
    }
  };

  // Track focus for subject input
  const handleSubjectFocus = () => {
    setLastFocusedElement('subject');
  };

  // Track focus for TinyMCE editor
  const handleEditorFocus = () => {
    setLastFocusedElement('editor');
  };

  const [emailData, setEmailData] = useState({
    TemplateName: '',
    Body: '',
    Subject: '',
  });

  const handleInputChange = (field, value) => {
    setEmailData(prev => {
      const newData = {
        ...prev,
        [field]: value,
      };
      if (field === 'Body' || field === 'Subject') {
        extractVariables(newData.Body, newData.Subject);
      }
      return newData;
    });
  };

  const editorConfig = {
    width: '98%',
    height: 400,
    plugins: [
      'advlist autolink lists link image charmap print preview hr anchor pagebreak',
      'searchreplace wordcount visualblocks visualchars code fullscreen',
      'insertdatetime media nonbreaking save table contextmenu directionality',
      'emoticons template paste textcolor'
    ],
    toolbar1: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
    toolbar2: 'print preview media | forecolor backcolor emoticons',
    setup: (editor) => {
      editor.on('init', function () {
        editorRef.current = editor;
      });
      editor.on('focus', handleEditorFocus);
    }
  };

  // Modified email data state management
  // const handleInputChange = (field, value) => {
  //   setEmailData(prev => {
  //     const newData = {
  //       ...prev,
  //       [field]: value,
  //     };
  //     if (field === 'Body' || field === 'Subject') {
  //       extractVariables(newData.Body, newData.Subject);
  //     }
  //     return newData;
  //   });
  // };

  // const editorConfig = {
  //   width: '98%',
  //   height: 400,
  //   plugins: [
  //     'advlist autolink lists link image charmap print preview hr anchor pagebreak',
  //     'searchreplace wordcount visualblocks visualchars code fullscreen',
  //     'insertdatetime media nonbreaking save table contextmenu directionality',
  //     'emoticons template paste textcolor',
  //   ],
  //   toolbar1: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image ',
  //   toolbar2: 'print preview media | forecolor backcolor emoticons',
  // };

  const navigate = useNavigate();
  const { state } = useLocation();
  const BUId = sessionStorage.getItem('BUId');

  const handleCustomRedirect = () => {
    navigate('/TemplateList');
  };

  const extractVariables = (content, subject) => {
    const regex = /{([^}]+)}/g;
    const bodyMatches = content.match(regex) || [];
  //  const subjectMatches = subject.match(regex) || [];
    const allMatches = [...bodyMatches,
      // ...subjectMatches
    ];
    const uniqueVariables = [...new Set(allMatches.map(match => match.slice(1, -1)))];
    setVariables(uniqueVariables);
  };

  const validateTags = (tags) => {
    const invalidTags = tags.filter(tag => !dropdownTags.includes(tag));
    return invalidTags;
  };

  // const handleInputChange = (field, value) => {
  //   setEmailData(prev => {
  //     const newData = {
  //       ...prev,
  //       [field]: value,
  //     };
  //     if (field === 'Body' || field === 'Subject') {
  //       extractVariables(newData.Body, newData.Subject);
  //     }
  //     return newData;
  //   });
  // };

  useEffect(() => {
    initializeCustomPlugin();

    if (state?.userData) {
      const { templateName, templateSubject, templateContent } = state.userData;
      const newData = {
        TemplateName: templateName,
        Body: templateContent,
        Subject: templateSubject,
      };
      setEmailData(newData);
      extractVariables(templateContent, templateSubject);
    }
  }, [state?.userData]);

  useEffect(() => {
    const fetchFromEmailOptions = async () => {
      if (!isModalOpen) return;

      try {
        const response = await fetch(`${apiUrl}/Mailer/GetFromMails?BUId=${BUId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch FromEmail data');
        }
        const data = await response.json();
        if (data && data[0].fromEmails) {
          setFromEmailOptions(data[0].fromEmails);
        } else {
          throw new Error('Invalid response format');
        }
      } catch (error) {
        console.error('Error fetching FromEmail options:', error);
      }
    };

    fetchFromEmailOptions();
  }, [isModalOpen, BUId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailData.TemplateName || !emailData.Body || !emailData.Subject) {
      alert('Please fill in all required fields');
      return;
    }

    if (!BUId) {
      alert('BUId is required! Please log in again.');
      return;
    }

    // Validate that all tags are from dropdown
    const invalidTags = validateTags(variables);
    if (invalidTags.length > 0) {
      alert(`Error: The following tags unavailable: ${invalidTags.join(', ')}\nPlease choose tags from the list.`);
      return;
    }

    setIsSubmitting(true);

    try {
      const requestData = {
        BUId: BUId,
        TemplateId: state?.userData?.templateId || emailData.templateId,
        TemplateName: emailData.TemplateName,
        TemplateContent: emailData.Body,
        TemplateSubject: emailData.Subject,
        MailTags: variables,
        CreatedOn: format(new Date(), 'dd/MM/yyyy hh:mm a'),
      };

      const url = state?.userData?.templateId
        ? `${apiUrl}/Mailer/UpdateTemplate`
        : `${apiUrl}/Mailer/CreateTemplate`;
      const method = state?.userData?.templateId ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData));
      }

      alert(state?.userData ? 'Template Updated Successfully!' : 'Template Created Successfully!');
      setEmailData({ TemplateName: '', Body: '', Subject: '' });
      setVariables([]);
    } catch (error) {
      console.error('Error creating/updating template:', error);
      alert(`Failed to create/update template: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };
  const showPreview = () => {
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    if (!emailData.TemplateName || !emailData.Body || !emailData.Subject) {
      alert('Please fill in all required fields');
      return;
    }

    if (!BUId) {
      alert('BUId is required! Please log in again.');
      return;
    }

    try {
      const sendData = {
        BUId: BUId,
        Body: emailData.Body,
        Subject: emailData.Subject,
        RequestTime: format(new Date(), 'dd/MM/yyyy hh:mm a'),
        FromEmail: dropdownValue,
        ToEmail: textAreaValue,
      };

      const response = await fetch(`${apiUrl}/Mailer/SendSampleTemplateMail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(sendData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData));
      }

      alert('Sample email sent successfully!');
    } catch (error) {
      console.error('Error sending sample email:', error);
      alert(`Failed to send sample email: ${error.message}`);
    } finally {
      closeModal();
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
            <div className="flex justify-end mb-4">
        <BackButton label="Back" onClickRedirect={handleCustomRedirect} />
      </div>

      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-gray-900 flex justify-between items-center mb-6">
          {state?.userData ? 'MAKE CHANGES TO YOUR TEMPLATE HERE' : 'CREATE YOUR TEMPLATE'}
        </h1>
      </div>

      <div className="flex gap-6">
        <div className="flex-grow">
          <div className="p-6 bg-white shadow-lg rounded-xl">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Template Name  <span className="text-red-500">*</span></label>
                
                <input
                  type="text"
                  value={emailData.TemplateName}
                  onChange={(e) => handleInputChange('TemplateName', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Subject <span className="text-red-500">*</span></label>
                <input
                  ref={subjectInputRef}
                  type="text"
                  value={emailData.Subject}
                  onChange={(e) => handleInputChange('Subject', e.target.value)}
                  onFocus={handleSubjectFocus}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Body <span className="text-red-500">*</span>
                </label>
                <Editor
                 onInit={(evt, editor) => {
                  tinyMceEditorRef.current = editor;  
                }}
                  value={emailData.Body}
                  init={{
                    ...editorConfig,
                    
                    setup: (editor) => {
                      editor.on('focus', handleEditorFocus);
                    }
                  }}
                  onEditorChange={(content) => handleInputChange('Body', content)}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full flex items-center justify-center px-4 py-3 rounded-md text-white font-semibold ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'
                  } focus:outline-none focus:ring-2 focus:ring-blue-500`}
              >
                {isSubmitting ? 'Saving...' : state?.userData ? 'UPDATE' : 'CREATE'}
              </button>
            </form>
          </div>
        </div>
        {/* 
        <div className="w-64">
          <button
            onClick={openModal}
            className="mb-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Take A Trial
          </button>
          <div className="p-4 bg-white shadow-lg rounded-xl sticky top-4">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">Template Tags</h2>
            {variables.length > 0 ? (
              <ul className="space-y-2">
                {variables.map((variable, index) => (
                  <li
                    key={index}
                    className="px-3 py-2 bg-blue-50 text-blue-700 rounded-md font-medium"
                  >
                    {variable}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 text-sm">
                No variables detected. Add variables using {"{variable}"} syntax in the template subject or body.
              </p>
            )}
            {isModalOpen && (
              <div className="w-full fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-xl w-full" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                  <h3 className="text-lg font-semibold mb-4">Mail Your Template</h3>
                  <div className="mb-4">
                    <label htmlFor="dropdown" className="block text-sm font-medium text-gray-700 mb-2">
                      Mail From
                    </label>
                    <select
                      id="dropdown"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md"
                      value={dropdownValue}
                      onChange={(e) => setDropdownValue(e.target.value)}
                    >
                      <option value="">Select...</option>
                      {fromEmailOptions.map((email, index) => (
                        <option key={index} value={email}>{email}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="text-area" className="block text-sm font-medium text-gray-700 mb-2">
                      Mail To
                    </label>
                    <textarea
                      id="text-area"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md"
                      rows="4"
                      value={textAreaValue}
                      onChange={(e) => setTextAreaValue(e.target.value)}
                    />
                  </div>
                  <div className="mb-4">
                    <label style={{ fontStyle: 'italic', fontSize: '12px' }}>
                      * For multiple receivers separate it by comma
                    </label>
                  </div>
                  <div className="flex justify-end space-x-2">
                    <button
                      onClick={closeModal}
                      className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSave}
                      className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div> */}
        <div className="w-64">
          <button
           onClick={showPreview}
            className="mb-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Preview
          </button>
          {/* Preview Modal */}
          {isPreviewOpen && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-30">
              <div className="bg-white p-6 rounded-lg shadow-lg max-w-xl w-full">
                <h3 className="text-lg font-semibold mb-4">Preview: {emailData.TemplateName}</h3>
                <div className="mb-4">
                  <div
                    className="preview-body"
                    dangerouslySetInnerHTML={{ __html: emailData.Body }}
                  />
                </div>
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={closePreview}
                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          <button
            onClick={openModal}
            className="mb-4 px-4 py-2 ml-5 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Take A Trial
          </button>
          <div className="p-4 bg-white shadow-lg rounded-xl sticky top-4">
            {/* <h2 className="text-lg font-semibold text-gray-900 mb-3">Template Tags</h2>
          {variables.length > 0 ? (
            <ul className="space-y-2">
              {variables.map((variable, index) => (
                <li
                  key={index}
                  className="px-3 py-2 bg-blue-50 text-blue-700 rounded-md font-medium"
                >
                  {variable}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 text-sm">
              No variables detected. Add variables using {"{variable}"} syntax in the template subject or body.
            </p>
          )} */}

            {/* New Available Tags Box */}
            <div className="mt-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">Available Tags</h2>
              <div className="max-h-60 overflow-y-auto">
                <ul className="space-y-2">
                  {availableTags.map((tag, index) => (
                    <li
                      key={index}
                      onClick={() => handleTagClick(tag)}
                      className="px-3 py-2 bg-gray-50 text-gray-700 rounded-md font-medium cursor-pointer hover:bg-gray-100 transition-colors"
                    >
                      {tag}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Modal code remains the same */}
          {isModalOpen && (
            <div className="w-full fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
              <div className="bg-white p-6 rounded-lg shadow-lg max-w-xl w-full" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                <h3 className="text-lg font-semibold mb-4">Mail Your Template</h3>
                <div className="mb-4">
                  <label htmlFor="dropdown" className="block text-sm font-medium text-gray-700 mb-2">
                    Mail From
                  </label>
                  <select
                    id="dropdown"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    value={dropdownValue}
                    onChange={(e) => setDropdownValue(e.target.value)}
                  >
                    <option value="">Select...</option>
                    {fromEmailOptions.map((email, index) => (
                      <option key={index} value={email}>{email}</option>
                    ))}
                  </select>
                </div>

                <div className="mb-4">
                  <label htmlFor="text-area" className="block text-sm font-medium text-gray-700 mb-2">
                    Mail To
                  </label>
                  <textarea
                    id="text-area"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    rows="4"
                    value={textAreaValue}
                    onChange={(e) => setTextAreaValue(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <label style={{ fontStyle: 'italic', fontSize: '12px' }}>
                    * For multiple receivers separate it by comma
                  </label>
                </div>
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={closeModal}
                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSave}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default CreateTemplate;